var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTshirtLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9137 4.4805C16.91 4.47702 16.9062 4.4736 16.9023 4.4703L13.5995 1.83879C13.5693 1.81416 13.5342 1.79506 13.4959 1.7825L11.1066 1.01697C10.9437 0.963921 10.7636 1.03938 10.7044 1.18549C10.6937 1.21184 10.6875 1.23946 10.6859 1.26746C10.6859 1.32938 10.5823 2.7563 8.99058 2.77882C7.3894 2.7563 7.28894 1.32938 7.2858 1.26746C7.27654 1.11224 7.12866 0.993156 6.95551 1.00146C6.92577 1.0029 6.89637 1.00811 6.86824 1.01697L4.48217 1.79095C4.44386 1.8035 4.4087 1.82261 4.37856 1.84723L1.09771 4.4703C0.972015 4.57735 0.966913 4.7555 1.08633 4.86819C1.09002 4.87167 1.09383 4.87508 1.09771 4.87839L3.70983 7.24534V13.7186C3.70983 13.874 3.85041 14 4.02379 14H13.9762C14.1496 14 14.2902 13.874 14.2902 13.7186V7.24534L16.9023 4.87839C17.028 4.77134 17.0331 4.59322 16.9137 4.4805ZM14.2807 6.44322V5.13732C14.2807 4.98189 14.1402 4.85587 13.9668 4.85587C13.7934 4.85587 13.6528 4.98189 13.6528 5.13732V13.423H4.32519V5.13732C4.32519 4.98189 4.18461 4.85587 4.01123 4.85587C3.83785 4.85587 3.69727 4.98189 3.69727 5.13732V6.44603L1.76644 4.69264L4.75531 2.29473L6.72068 1.65867C6.96415 2.78325 8.17849 3.51799 9.43299 3.29973C10.3594 3.13854 11.0838 2.48917 11.2636 1.65867L13.229 2.29473L16.2084 4.69264L14.2807 6.44322Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirtLinear);
export default __webpack_public_path__ + "static/media/tshirt-linear.5789099d99c5e2b236bf1e3b64087a70.svg";
export { ForwardRef as ReactComponent };